import styled from 'styled-components';

const OptionalSections = styled.div`
  > div {
    :last-child {
      border-bottom: none;
      padding-bottom: 0px;
    }
  }
  .optinalSection {
    font-family: Hind;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
  }
`;

export { OptionalSections };
